import { useState, useEffect } from "react";
import { useModal } from "../../hooks";
import LavorisService from "../../services/LavorisService";
import EditRRHHTurnSRes from "../others/userModule/RRHHTurnSRes/editRRHHTurnSRes";
import AddRRHHTurnSRes from "../others/userModule/RRHHTurnSRes/addRRHHTurnSRes";
import InfiniteTable from "../../components/others/InfiniteTableComponent/IntiniteTableComponent";
import { getUserRolesTableColumns } from "./userRolesTableColumns";

const ADD_RRHH_APPOINTMENTS_AND_ABSENTEE_MODAL = "addRRHH_APPOINTMENTS_AND_ABSENTEEModal";
const EDIT_RRHH_APPOINTMENTS_AND_ABSENTEE_MODAL = "editRRHH_APPOINTMENTS_AND_ABSENTEEModal";

const RRHHTurnSRes = () => {
  const LavorisInstance = LavorisService.getInstance();
  // useStates
  const [tableLoading, setTableLoading] = useState(true);
  const { openModal, closeModal, isActive } = useModal();
  const [RRHH_APPOINTMENTS_AND_ABSENTEEs, setRRHH_APPOINTMENTS_AND_ABSENTEEs] = useState<any[]>([]);
  const [RRHH_APPOINTMENTS_AND_ABSENTEE, setRRHH_APPOINTMENTS_AND_ABSENTEE] = useState<any>(null);

  const getItems = async () => {
    setTableLoading(true);
    try {
      const response = await LavorisInstance.User.findUsersByRoleAlias("RRHH_APPOINTMENTS_AND_ABSENTEE");
      setRRHH_APPOINTMENTS_AND_ABSENTEEs(response);
    } catch (error) {
      console.log(error);
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => {
    const getData = async () => {
      await getItems();
    };
    getData();
  }, []);

  // Configuración de columnas para la tabla
  const requestedTurnsColumns = getUserRolesTableColumns((rowData) => {
    openModal(EDIT_RRHH_APPOINTMENTS_AND_ABSENTEE_MODAL, rowData.id);
    setRRHH_APPOINTMENTS_AND_ABSENTEE(rowData);
  });

  return (
    <>
      <div className="custom-header mt-sm-4 mt-0 pt-2">
        <div className="header-controls">
          {/* Search Section */}
          <div className="search-section">
          </div>

          {/* Actions Section */}
          <div className="actions-section">
            <button
              type="button"
              className="add-btn"
              onClick={() => {
                openModal(ADD_RRHH_APPOINTMENTS_AND_ABSENTEE_MODAL);
              }}
              title="Agregar"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M8 3.333v9.334M3.333 8h9.334"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="btn-text">Agregar</span>
            </button>
          </div>
        </div>
      </div>

      <InfiniteTable
        data={RRHH_APPOINTMENTS_AND_ABSENTEEs}
        columns={requestedTurnsColumns}
        loading={tableLoading}
        hasMore={false}
        onLoadMore={() => { }}
        height={300}
        emptyMessage="Momentáneamente no hay datos para mostrar"
        loadingMessage={RRHH_APPOINTMENTS_AND_ABSENTEEs.length === 0 ? "Cargando datos..." : "Buscando más datos..."}
        striped
        hover
        bordered
      />

      {isActive(ADD_RRHH_APPOINTMENTS_AND_ABSENTEE_MODAL) && (
        <AddRRHHTurnSRes
          show
          urlTittle={ADD_RRHH_APPOINTMENTS_AND_ABSENTEE_MODAL}
          onClose={() => closeModal(ADD_RRHH_APPOINTMENTS_AND_ABSENTEE_MODAL)}
          modalTittle="Agregar RRHH Turnos S/Res"
          tableLoading={getItems}
        />
      )}
      {isActive(EDIT_RRHH_APPOINTMENTS_AND_ABSENTEE_MODAL) && (
        <EditRRHHTurnSRes
          show
          urlTittle={EDIT_RRHH_APPOINTMENTS_AND_ABSENTEE_MODAL}
          onClose={() => closeModal(EDIT_RRHH_APPOINTMENTS_AND_ABSENTEE_MODAL)}
          modalTittle="Editar RRHH Turnos S/Res"
          data={RRHH_APPOINTMENTS_AND_ABSENTEE}
          tableLoading={getItems}
        />
      )}
    </>
  );
};

export default RRHHTurnSRes;
